<template>
  <div class="row mx-auto">
    <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-skeleton type="input"></b-skeleton>
        </template>
        <h1 class="mt-4 mb-4 text-center">
          Modifier {{ getCategory.hierarchyLabel }} ({{
            getCategory.hierarchyCode
          }})
        </h1>
      </b-skeleton-wrapper>
      <edit-categorie-mapping
        @reload="getMiraklCategoryInfo"
        :categoryMirakl="getCategory"
      />
      <add-mapping
        :categoryMirakl="getCategory"
        @reload="getMiraklCategoryInfo"
      />
      <delete-mapping :mapping="mapping" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DeleteMapping from "@/views/categories/edit/DeleteMapping";
import EditCategorieMapping from "@/views/categories/edit/EditCategorieMapping";
import AddMapping from "@/views/categories/edit/AddMapping";

export default {
  name: "EditCategory",
  components: {
    AddMapping,
    EditCategorieMapping,
    DeleteMapping
  },
  data() {
    return {
      httpMirakl: this.$gwzApi.service("categories"),
      categoriesLegacy: [],
      categoryMirakl: {},
      mappingForm: {
        categoriesLegacy: []
      },
      validationContext: {}
    };
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },

  methods: {
    getMiraklCategoryInfo() {
      this.$store.dispatch("categories/getMiraklCategoryInfo", this.id);
    }
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      getCategory: "categories/getCategory"
    }),
    mapping() {
      return this.getCategory.mapping;
    }
  },
  mounted() {
    this.getMiraklCategoryInfo();
  }
};
</script>

<style></style>
